<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        لیست نظرسنجی ها
      </h4>
    </b-card-header>
    <b-card-body>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        v-b-toggle.filter-box
        variant="outline-primary"
        class="mb-1"
      >
        <feather-icon
          icon="FilterIcon"
          class="mr-50"
        />
        <span class="align-middle">جستجو</span>
      </b-button>
      <b-collapse
        id="filter-box"
        class="mb-2"
      >
        <b-card class="border mb-0">
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label>عنوان:</label>
                <b-form-input
                  v-model="search.title"
                  placeholder="نام را وارد نمایید."
                  type="text"
                  class="d-inline-block"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label=" تاریخ ایجاد"
                label-for="due-date"
              >
                <date-picker
                  v-model="search.createdDate"
                  type="date"
                  display-format="jDD jMMMM jYYYY"
                  format="YYYY-MM-DD"
                  clearable
                />

              </b-form-group>
            </b-col>
          </b-row>

          <hr>
          <div class="demo-inline-spacing">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="primary"
              @click="advanceSearch"
            >
              اعمال جستجو
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-secondary"
              @click="clearSearch"
            >
              حذف فیلترها
            </b-button>
          </div>
        </b-card>
      </b-collapse>

      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table
            :fields="fields"
            :items="items"
            hover
            striped
          >
            <template #table-busy>
              <div class="text-center text-info my-2">
                <b-spinner class="align-middle" />
                <strong> درحال دریافت اطلاعات...</strong>
              </div>
            </template>

            <template #cell(action)="data">
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-primary"
                @click="$router.push({name: 'My_Vote_Detail', params:{id: data.item.id}})"
              >
                <feather-icon
                  icon="FileTextIcon"
                  class="mr-50"
                />
                <span class="align-middle">مشاهده</span>
              </b-button>
            </template>

          </b-table>
          <b-pagination
            v-model="currentPage"
            class="mt-2"
            :total-rows="totalRows"
            :per-page="perPage"
          />
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BSpinner,
  BOverlay,
  BPagination, BFormInput, BCollapse, BFormGroup, BButton, VBToggle,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { doubleRaf, queryString } from '@/libs/utils'

export default {
  name: 'VoteList',
  components: {
    BButton,
    BFormGroup,
    BCollapse,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BSpinner,
    BOverlay,
    BPagination,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: 'شناسه',
        },
        {
          key: 'title',
          label: 'عنوان',
        },
        {
          key: 'createdDate',
          label: 'تاریخ ساخت',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      items: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      onProgress: true,
      search: {},
      rolesList: [],
      permissionList: [],
      receiversList: [],
      getReceivers: false,
      onExportProgress: false,
    }
  },

  computed: {
    exportExcel() {
      const query = queryString(this.search)
      return `${process.env.VUE_APP_API}my-votes?export-excel=1&${query}`
    },
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$router.push({
          name: 'Votes_Index',
          query: { page: this.currentPage },
        })
        this.items = []
        this.getVoteList()
      }
    },
  },

  mounted() {
    this.getVoteList()
    this.setSearchData()
  },
  methods: {
    getVoteList() {
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query))
      this.onProgress = true

      this.$http.get('my-votes', {
        params: {
          ...currentQuery,
          ...this.search,
          page: this.currentPage,
        },
      })
        .then(({ data }) => {
          if (data.status) {
            this.items = data.votes
            this.currentPage = data.meta.current_page
            this.totalRows = data.meta.total
            this.perPage = data.meta.per_page
          } else {
            this.$bvToast.toast(data.message ?? 'در دریافت لیست کاربران خطایی رخ داده', {
              title: 'حطا',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onProgress = false
        })
    },
    advanceSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.search,
        },
      })
        .then(() => {
          this.getVoteList()
        })
        .catch(() => {
        })

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    clearSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {},
      })
        .then(() => {
          this.getVoteList()
        })
        .catch(() => {
        })

      this.search = {}
      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    setSearchData() {
      doubleRaf(() => {
        this.search = JSON.parse(JSON.stringify(this.$route.query))
      })
    },
  },
}
</script>

<style>

</style>
